import {BlockEmbed} from './block';
import Link from './../formats/link';
import $script from 'scriptjs';

class Tweet extends BlockEmbed {
  static create(value) {
    let node = super.create();
    let url = this.sanitize(value);
    let id = url.substr(url.lastIndexOf('/') + 1);
    node.dataset.url = url;
  
    if (!/^[0-9]+$/.test(id)) {
      console.error(`Invalid tweet url: ${url}\nUse https://twitter.com/nickname/status/1234567890123456789`);
      return node;
    }
    
    this.createTweet(id, node);
    return node;
  }
  
  static value(domNode) {
    return domNode.dataset.url;
  }
  
  static sanitize(url) {
    if (url.indexOf('?') !== -1) {
      url = url.substring(0, url.indexOf('?'));
    }
    return Link.sanitize(url) // eslint-disable-line import/no-named-as-default-member
  }
  
  static createTweet(id, node) {
    const callback = function() {window.twttr.widgets.createTweet(id, node)};
    
    if (window.twttr) {
      callback();
    } else {
      $script('//platform.twitter.com/widgets.js', callback);
    }
  }
}
Tweet.blotName = 'tweet';
Tweet.tagName = 'tweet';

export default Tweet;